class RecentlyViewedProducts {
  constructor() {
    this.storageKey = "recently_viewed_products";
    this.limit = 8;

    this.saveCurrentProduct();

    document.addEventListener("DOMContentLoaded", () => {
      this.loadProducts();
    });
  }

  saveCurrentProduct() {
    if (!window.location.pathname.includes("/products/")) return;

    const handle = window.location.pathname
      .split("/products/")[1]
      .split("?")[0];

    let products = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    products = products.filter((item) => item !== handle);

    products.unshift(handle);

    if (products.length > this.limit) {
      products = products.slice(0, this.limit);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(products));
  }

  async loadProducts() {
    const container = document.querySelector("[data-recently-viewed]");

    if (!container) return;

    const grid = container.querySelector(".recently-viewed-grid");

    let handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    if (window.location.pathname.includes("/products/")) {
  const current = window.location.pathname
    .split("/products/")[1]
    .split("?")[0];

  handles = handles.filter((item) => item !== current);
}

// Hide section only if there are no recently viewed products
if (handles.length === 0) {
  container.style.display = "none";
  return;
}

    for (const handle of handles) {
      try {
        const response = await fetch(`/products/${handle}.js`);

        if (!response.ok) continue;

        const product = await response.json();
        console.log("Product:", product);

        const card = document.createElement("div");
card.className = "recent-product-card";
        card.innerHTML = `
<a href="/products/${product.handle}" class="recent-product">

  <div class="recent-product__image">
    <img
src="${product.featured_image ? product.featured_image : product.images[0]}&width=600"
      alt="${product.title}"
      loading="lazy">
  </div>

  <h3 class="recent-product__title">
    ${product.title}
  </h3>

  <div class="recent-product__price">
    ${new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(product.price / 100)}
  </div>

</a>
`;
        console.log("Card HTML:", card);
        grid.appendChild(card);
        console.log("Card Added");

      } catch (e) {
  console.error("Recently Viewed Error:", e);
}
    }
  }
}

new RecentlyViewedProducts();